<div class="login-container">
  <div class="header"><img src="assets/images/common/logo.png" [alt]="'LogChain' | translate"></div>
  <div class="main-container">
    <div class="login-card align-center-item">
      <div class="header-cart mb-5">
        <div class="top">
          <div class="left">
            {{'Welcome to' | translate}} <b>Log</b>Chain!
          </div>
          <div class="right">{{ getToday() }}</div>
        </div>
        <div class="title text-center mt-3">{{'New Password' | translate}}</div>
        <ngb-alert class="mt-3" *ngIf="errorMsg != ''" [type]="'danger'" [dismissible]="false">{{ errorMsg }}
        </ngb-alert>
      </div>
      <form [formGroup]="setPasswordForm" (ngSubmit)="setPassword()">
        <div class="form-group">
          <div class="input-group">
            <input [type]="hide ? 'password' : 'text'" class="form-control" formControlName="password" required
              [placeholder]="'Enter your password' | translate ">
            <div class="input-group-append">
              <span (click)="hide = !hide" class="input-group-text">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </span>
            </div>
          </div>
          <small *ngIf="formControl.password.touched && formControl.password.invalid"
            class="form-text text-danger">{{getPasswordErrorMessage()}}</small>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input [type]="hide ? 'password' : 'text'" class="form-control" formControlName="confirmPassword" required
              [placeholder]="'Enter confirm password' | translate ">
            <div class="input-group-append">
              <span (click)="hide = !hide" class="input-group-text">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </span>
            </div>
          </div>
          <small *ngIf="formControl.confirmPassword.touched && formControl.confirmPassword.invalid"
            class="form-text text-danger">{{getConfirmPasswordErrorMessage()}}</small>
        </div>
        <div class="d-grid">
          <button [disabled]="setPasswordForm.invalid" class="btn btn-primary btn-block" (click)="setPassword()">
            <span *ngIf="!isLoading">{{ 'Set password' | translate | uppercase }}</span>
            <div *ngIf="isLoading" class="spinner-border" role="status"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
